/* Cuadra Piedreros — Bundle (cp-*.js concatenated)
 * Auto-generated. Do not edit directly. Edit source files and rebuild.
 */
/* =====
 cp-utm.js ===== */
(function () {
  'use strict';
  const STORAGE_KEY = 'cp_utm_v1';
  const PARAMS = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content',
                  'gclid','fbclid','ttclid','msclkid','referrer'];
  function getStored() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function captureFromURL() {
    const url = new URL(window.location.href);
    const stored = getStored();
    let updated = false;
    PARAMS.forEach(p => {
      const v = url.searchParams.get(p);
      if (v) {
        stored[p] = v;
        updated = true;
      }
    });
    if (!stored.first_landing) {
      stored.first_landing = window.location.href;
      stored.first_landing_at = new Date().toISOString();
      updated = true;
    }
    if (document.referrer && !stored.referrer) {
      stored.referrer = document.referrer;
      updated = true;
    }
    if (updated) localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    return stored;
  }
  function attachToCheckout() {
    const data = getStored();
    if (Object.keys(data).length === 0) return;
    document.querySelectorAll('a[href*="/checkout"], a[href*="/cart"]').forEach(a => {
      try {
        const url = new URL(a.href, window.location.origin);
        Object.keys(data).forEach(k => {
          if (k.startsWith('utm_') && !url.searchParams.has(k)) {
            url.searchParams.set(k, data[k]);
          }
        });
        a.href = url.toString();
      } catch (e) {}
    });
  }
  function pushToKlaviyo() {
    const data = getStored();
    if (!Object.keys(data).length) return;
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('UTM Captured', data);
      }
    } catch (err) {}
  }
  function injectHidden() {
    const data = getStored();
    document.querySelectorAll('form').forEach(form => {
      Object.keys(data).forEach(k => {
        if (form.querySelector('input[name="' + k + '"]')) return;
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = k;
        i.value = data[k];
        form.appendChild(i);
      });
    });
  }
  function init() {
    captureFromURL();
    attachToCheckout();
    injectHidden();
    setTimeout(pushToKlaviyo, 2000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.CPUtm = { get: getStored, capture: captureFromURL };
})();
/* =====
 cp-locale-banner.js ===== */
(function () {
  'use strict';
  /* DESACTIVADO 2026-07-02 por Ruben (El Cardenal): letrero flotante "Quieres ver el sitio en espanol" apagado. Reactivar: borra el 'return;' de la sig. linea. Fuente: assets/cp-locale-banner.js */
  return;
  const KEY_DISMISSED = 'cp_locale_banner_dismissed_v1';
  if (localStorage.getItem(KEY_DISMISSED)) return;
  const currentLocale = (document.documentElement.lang || 'en').toLowerCase();
  if (currentLocale.startsWith('es')) return;  // Already on Spanish, no banner
  const langs = (navigator.languages || [navigator.language || 'en']).map(l => l.toLowerCase());
  const wantsSpanish = langs.some(l => l.startsWith('es'));
  const tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
  const mxTz = tz.includes('america/mexico') || tz.includes('america/monterrey') ||
               tz.includes('america/cancun') || tz.includes('america/tijuana');
  if (!wantsSpanish && !mxTz) return;
  function build() {
    const banner = document.createElement('div');
    banner.className = 'cp-locale-banner';
    banner.innerHTML = `
      <div class="cp-locale-banner__inner">
        <span class="cp-locale-banner__flag" aria-hidden="true">🇲🇽</span>
        <span class="cp-locale-banner__text">¿Quieres ver el sitio en español?</span>
        <a href="/es/" class="cp-locale-banner__cta" data-no-instant>Ver en Español</a>
        <button type="button" class="cp-locale-banner__close" aria-label="Cerrar">×</button>
      </div>
    `;
    document.body.appendChild(banner);
    banner.querySelector('.cp-locale-banner__close').addEventListener('click', function () {
      localStorage.setItem(KEY_DISMISSED, '1');
      banner.classList.remove('cp-locale-banner--show');
      setTimeout(() => banner.remove(), 300);
    });
    requestAnimationFrame(() => banner.classList.add('cp-locale-banner--show'));
  }
  function init() {
    setTimeout(build, 1500);  // soft delay
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
/* =====
 cp-wishlist.js ===== */
(function () {
  'use strict';
  const isES = (document.documentElement.lang || 'en').toLowerCase().startsWith('es');
  const STORAGE_KEY = 'cp_wishlist_v1';
  const EVENT_CHANGE = 'cp:wishlist:change';
  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent(EVENT_CHANGE, { detail: { list } }));
  }
  function has(id) { return read().includes(String(id)); }
  function toggle(id) {
    const list = read();
    const sid = String(id);
    const idx = list.indexOf(sid);
    if (idx === -1) { list.push(sid); } else { list.splice(idx, 1); }
    write(list);
    return idx === -1;
  }
  function count() { return read().length; }
  function clear() { write([]); }
  function syncButton(btn) {
    const id = btn.getAttribute('data-product-id');
    if (!id) return;
    const active = has(id);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('cp-wishlist-button--active', active);
    const label = btn.querySelector('.cp-wishlist-button__label');
    if (label) label.textContent = active ? 'Saved' : 'Save';
  }
  function syncAllButtons() {
    document.querySelectorAll('.cp-wishlist-button').forEach(syncButton);
  }
  function syncCounters() {
    const c = count();
    document.querySelectorAll('.cp-wishlist-count').forEach(function (el) {
      el.textContent = c;
      el.style.display = c > 0 ? '' : 'none';
    });
  }
  async function renderWishlistPage(container) {
    const ids = read();
    if (ids.length === 0) {
      container.innerHTML =
        '<div class="cp-wl-empty"><p class="h5">Your wishlist is empty.</p>' +
        '<p>Save the pieces you love. Click the ♡ on any product to add it here.</p>' +
        '<a href="/collections/all-products" class="button">Start shopping</a></div>';
      return;
    }
    container.innerHTML = '<p class="cp-wl-loading">Loading your saved items…</p>';
    const cards = [];
    for (const id of ids) {
      try {
        const r = await fetch('/products/' + id + '.js?cb=' + Date.now()).catch(() => null);
        if (!r || !r.ok) {
          continue;
        }
        const data = await r.json();
        const img = data.featured_image || (data.images && data.images[0]) || '';
        const price = (data.price / 100).toFixed(2);
        cards.push(
          '<a class="cp-wl-card" href="' + data.url + '">' +
          '<div class="cp-wl-card__media">' +
          (img ? '<img src="' + img + '" alt="' + data.title + '" loading="lazy">' : '') +
          '<button type="button" class="cp-wl-card__remove cp-wishlist-button cp-wishlist-button--active" data-product-id="' + data.handle + '" aria-label="Remove from wishlist">✕</button>' +
          '</div>' +
          '<div class="cp-wl-card__info">' +
          '<p class="cp-wl-card__vendor">' + (data.vendor || 'Cuadra Piedreros') + '</p>' +
          '<p class="cp-wl-card__title">' + data.title + '</p>' +
          '<p class="cp-wl-card__price">$' + price + '</p>' +
          '</div></a>'
        );
      } catch (e) {  }
    }
    container.innerHTML = '<div class="cp-wl-grid">' + cards.join('') + '</div>';
    syncAllButtons();
  }
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cp-wishlist-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute('data-product-id');
    if (!id) return;
    toggle(id);
    syncButton(btn);
    syncCounters();
    const wasAdded = has(id);
    showToast(wasAdded ? (isES?"♡ Agregado a tu lista":"♡ Added to wishlist") : (isES?"Quitado de tu lista":(isES?"Quitado de tu lista":"Removed from wishlist")));
    const wlContainer = document.querySelector('[data-cp-wishlist-page]');
    if (wlContainer) renderWishlistPage(wlContainer);
  });
  let toastTimer;
  function showToast(text) {
    let el = document.getElementById('cp-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cp-wl-toast';
      el.className = 'cp-wl-toast';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('cp-wl-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('cp-wl-toast--show'), 2000);
  }
  function init() {
    syncAllButtons();
    syncCounters();
    const wl = document.querySelector('[data-cp-wishlist-page]');
    if (wl) renderWishlistPage(wl);
  }
  document.addEventListener(EVENT_CHANGE, () => { syncAllButtons(); syncCounters(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.CPWishlist = { read, toggle, has, count, clear, render: renderWishlistPage };
})();
/* =====
 cp-reviews.js ===== */
(function () {
  'use strict';
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function stars(n) {
    n = Math.round(n) || 0;
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  }
  function fractStars(n) {
    n = parseFloat(n) || 0;
    const full = Math.floor(n);
    const half = (n - full) >= 0.5;
    let s = '';
    for (let i = 0; i < full; i++) s += '★';
    if (half) s += '½';
    for (let i = 0; i < (5 - full - (half ? 1 : 0)); i++) s += '☆';
    return s;
  }
  function relTime(iso) {
    if (!iso) return '';
    const t = new Date(iso).getTime();
    const days = Math.floor((Date.now() - t) / 86400000);
    if (days === 0) return 'today';
    if (days === 1) return 'yesterday';
    if (days < 30) return days + ' days ago';
    if (days < 365) return Math.floor(days / 30) + ' months ago';
    return Math.floor(days / 365) + ' years ago';
  }
  function renderList(reviews) {
    if (!reviews || !reviews.length) {
      return '<p class="cp-reviews-empty" style="color:#888;font-style:italic;">No reviews yet. Be the first to share your experience.</p>';
    }
    return reviews.map(function (r) {
      return '<div class="cp-review">' +
        '<div class="cp-review__stars">' + stars(r.rating) + '</div>' +
        '<div class="cp-review__header">' +
          '<span class="cp-review__author">' + escape(r.author) + (r.verified ? ' <small style="color:#8B1A1A;">✓ Verified</small>' : '') + '</span>' +
          '<span class="cp-review__date">' + relTime(r.date) + '</span>' +
        '</div>' +
        (r.title ? '<div class="cp-review__title">' + escape(r.title) + '</div>' : '') +
        '<div class="cp-review__body">' + escape(r.body) + '</div>' +
      '</div>';
    }).join('');
  }
  function escape(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function avgRating(reviews) {
    if (!reviews || !reviews.length) return 0;
    return reviews.reduce(function (a, r) { return a + (r.rating || 0); }, 0) / reviews.length;
  }
  function init() {
    $$('.cp-reviews').forEach(function (container) {
      const productId = container.getAttribute('data-product-id');
      let reviews = [];
      try {
        reviews = JSON.parse(container.getAttribute('data-reviews') || '[]');
      } catch (e) { reviews = []; }
      const avg = avgRating(reviews);
      const count = reviews.length;
      const summary = container.querySelector('.cp-reviews__summary');
      if (summary && count > 0) {
        summary.innerHTML =
          '<span class="cp-reviews__avg">' + avg.toFixed(1) + '</span>' +
          '<span class="cp-reviews__stars">' + fractStars(avg) + '</span>' +
          '<span class="cp-reviews__count">(' + count + ' review' + (count === 1 ? '' : 's') + ')</span>';
      }
      const list = container.querySelector('.cp-reviews__list');
      if (list) list.innerHTML = renderList(reviews);
      const form = container.querySelector('.cp-review-form');
      if (form) {
        const rateInput = form.querySelector('.cp-rating-input');
        if (rateInput) {
          const buttons = $$('button', rateInput);
          buttons.forEach(function (b, i) {
            b.addEventListener('click', function (e) {
              e.preventDefault();
              const val = i + 1;
              form.querySelector('input[name="rating"]').value = val;
              buttons.forEach(function (btn, idx) {
                btn.classList.toggle('is-active', idx < val);
              });
            });
          });
        }
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const fd = new FormData(form);
          const review = {
            product_id: productId,
            author: fd.get('author') || 'Anonymous',
            rating: parseInt(fd.get('rating') || '5', 10),
            title: fd.get('title') || '',
            body: fd.get('body') || '',
            email: fd.get('email') || '',
            date: new Date().toISOString(),
            status: 'pending'
          };
          const queue = JSON.parse(localStorage.getItem('cp_reviews_queue') || '[]');
          queue.push(review);
          localStorage.setItem('cp_reviews_queue', JSON.stringify(queue));
          try {
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
              window.klaviyo.identify({
                $email: review.email,
                cp_last_review_product: productId
              });
            }
            if (window.klaviyo && typeof window.klaviyo.track === 'function') {
              window.klaviyo.track('Submitted Product Review', {
                product_id: productId,
                rating: review.rating,
                title: review.title,
                body: review.body,
                author: review.author
              });
            }
          } catch (err) {}
          try {
            const params = new URLSearchParams();
            params.set('form_type', 'contact');
            params.set('utf8', '✓');
            params.set('contact[name]', '[REVIEW] ' + review.author);
            params.set('contact[email]', review.email);
            params.set('contact[body]', '★'.repeat(review.rating) + '\n\nProduct: ' + productId + '\nTitle: ' + review.title + '\n\n' + review.body);
            fetch('/contact#contact_form', { method: 'POST', body: params }).catch(function(){});
          } catch (err) {}
          let msg = form.querySelector('.cp-form-msg');
          if (!msg) {
            msg = document.createElement('div');
            msg.className = 'cp-form-msg cp-form-msg--ok';
            form.appendChild(msg);
          }
          msg.className = 'cp-form-msg cp-form-msg--ok';
          msg.textContent = 'Thank you! Your review has been submitted and will appear after moderation.';
          form.reset();
          $$('.cp-rating-input button', form).forEach(function (b) { b.classList.remove('is-active'); });
        });
      }
    });
    $$('.cp-card-rating[data-rating]').forEach(function (el) {
      const r = parseFloat(el.getAttribute('data-rating')) || 0;
      const c = parseInt(el.getAttribute('data-count') || '0', 10);
      const sEl = el.querySelector('.cp-card-rating__stars');
      const cEl = el.querySelector('.cp-card-rating__count');
      if (sEl) sEl.textContent = fractStars(r);
      if (cEl) cEl.textContent = c > 0 ? '(' + c + ')' : '';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
/* =====
 cp-size-guide.js ===== */
(function () {
  'use strict';
  const MEN_LENGTH_TO_US = [
    { in: 9.625, us: 7 }, { in: 9.937, us: 8 }, { in: 10.25, us: 9 },
    { in: 10.562, us: 10 }, { in: 10.875, us: 11 }, { in: 11.187, us: 12 },
    { in: 11.5, us: 13 }, { in: 11.812, us: 14 }
  ];
  const WOMEN_LENGTH_TO_US = [
    { in: 8.5, us: 5 }, { in: 8.75, us: 6 }, { in: 9.25, us: 7 },
    { in: 9.625, us: 8 }, { in: 9.875, us: 9 }, { in: 10.25, us: 10 },
    { in: 10.5, us: 11 }
  ];
  const BRAND_OFFSETS = {
    'tecovas':   0,  // True to size
    'lucchese':  0,  // True to size
    'ariat':    -0.5,// Size down half (Ariat runs large)
    'sneaker':   -1, // US sneaker size — boots run 1 size smaller
    'dress':     0   // US dress shoe — true to size
  };
  function lookupByLength(inches, gender) {
    const table = gender === 'women' ? WOMEN_LENGTH_TO_US : MEN_LENGTH_TO_US;
    let best = table[0];
    for (const row of table) {
      if (inches >= row.in - 0.15) best = row;
    }
    return best.us;
  }
  function lookupByBrand(currentSize, brand) {
    const offset = BRAND_OFFSETS[brand];
    if (offset === undefined) return currentSize;
    return Math.round((currentSize + offset) * 2) / 2;
  }
  function widthAdvice(width) {
    return {
      'narrow': 'Order width <strong>B</strong> (narrow). Sizes available on select styles.',
      'standard': 'Order width <strong>D</strong> (standard) — fits most.',
      'wide': 'Order width <strong>EE</strong> (wide). Available on most boots.',
      'extra-wide': 'Order width <strong>EEE</strong> (extra wide). Limited availability.'
    }[width] || '';
  }
  let modal;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cp-size-modal';
    const isES = (document.documentElement.lang || 'en').toLowerCase().startsWith('es');
    const t = isES ? {
      title: 'Encuentra tu talla perfecta',
      sub: 'Use any method — we\'ll recommend your Cuadra Piedreros size.',
      tab1: 'Medir pie',
      tab2: 'Por marca',
      tab3: 'Tabla',
      foot_intro: 'Stand on a sheet of paper with your full weight on one foot. Measure heel to longest toe, in inches.',
      shopping_for: 'Compro para',
      mens: 'Hombre',
      womens: 'Mujer',
      foot_length: 'Largo del pie (pulgadas)',
      foot_width: 'Ancho del pie',
      width_std: 'Standard (D)',
      width_narrow: 'Angosto (B)',
      width_wide: 'Ancho (EE)',
      width_xwide: 'Extra ancho (EEE)',
      calc: 'Calcular mi talla',
      brand_intro: 'Tell us your size in another brand and we\'ll convert it.',
      your_size: 'What size do you usually wear?',
      brand_q: 'In which brand or type of footwear?',
      brand_dress: 'Zapato formal US',
      brand_sneaker: 'Tenis US',
      mens_chart: 'Hombre',
      womens_chart: 'Mujer',
      width_legend: 'Ancho:',
      result_label: 'Tu talla Cuadra Piedreros',
      breakin: 'Handmade boots shape to your foot. Order this size — it should feel snug on day one and mold to you within a few weeks.'
    } : {
      title: 'Find Your Perfect Size',
      sub: "Use any method below — we'll recommend your Cuadra Piedreros size.",
      tab1: 'Measure Foot', tab2: 'By Brand', tab3: 'Chart',
      foot_intro: 'Stand on a piece of paper with full weight on one foot. Measure heel to longest toe in inches.',
      shopping_for: "I'm shopping for",
      mens: "Men's", womens: "Women's",
      foot_length: 'Foot length (inches)',
      foot_width: 'Foot width',
      width_std: 'Standard (D)', width_narrow: 'Narrow (B)',
      width_wide: 'Wide (EE)', width_xwide: 'Extra Wide (EEE)',
      calc: 'Calculate My Size',
      brand_intro: "Tell us your size in a brand you wear and we'll convert it.",
      your_size: 'What size do you usually wear?',
      brand_q: 'In which brand / shoe type?',
      brand_dress: 'US dress shoe',
      brand_sneaker: 'US sneaker',
      mens_chart: "Men's", womens_chart: "Women's",
      width_legend: 'Width:',
      result_label: 'Your Cuadra Piedreros size',
      breakin: 'Handmade boots break in to your foot. Order this size — they should feel snug on day one and conform to you over 2-4 weeks.'
    };
    modal.innerHTML = `
      <div class="cp-size-modal__inner">
        <button class="cp-size-modal__close" aria-label="Close">×</button>
        <h3>${t.title}</h3>
        <p class="cp-size-modal__sub">${t.sub}</p>
        <div class="cp-size-tabs">
          <button class="cp-size-tab cp-size-tab--active" data-tab="length">${t.tab1}</button>
          <button class="cp-size-tab" data-tab="brand">${t.tab2}</button>
          <button class="cp-size-tab" data-tab="chart">${t.tab3}</button>
        </div>
        <!-- TAB 1: Foot length -->
        <div class="cp-size-panel cp-size-panel--active" data-panel="length">
          <p style="font-size:13px;color:#6b6b6b;margin:0 0 8px;">
            ${t.foot_intro}
          </p>
          <div class="cp-size-question">
            <label>${t.shopping_for}</label>
            <select id="cp-sg-gender">
              <option value="men">${t.mens}</option>
              <option value="women">${t.womens}</option>
            </select>
          </div>
          <div class="cp-size-question">
            <label>${t.foot_length}</label>
            <input type="number" id="cp-sg-length" min="7" max="14" step="0.125" placeholder="e.g. 10.5">
          </div>
          <div class="cp-size-question">
            <label>${t.foot_width}</label>
            <select id="cp-sg-width">
              <option value="standard">${t.width_std}</option>
              <option value="narrow">${t.width_narrow}</option>
              <option value="wide">${t.width_wide}</option>
              <option value="extra-wide">${t.width_xwide}</option>
            </select>
          </div>
          <button class="cp-size-cta" data-action="calc-length">${t.calc}</button>
          <div class="cp-size-result" id="cp-sg-result-length" style="display:none;"></div>
        </div>
        <!-- TAB 2: By brand -->
        <div class="cp-size-panel" data-panel="brand">
          <p style="font-size:13px;color:#6b6b6b;margin:0 0 8px;">
            ${t.brand_intro}
          </p>
          <div class="cp-size-question">
            <label>${t.your_size}</label>
            <input type="number" id="cp-sg-brand-size" min="5" max="14" step="0.5" placeholder="e.g. 10">
          </div>
          <div class="cp-size-question">
            <label>${t.brand_q}</label>
            <select id="cp-sg-brand">
              <option value="tecovas">Tecovas (boot)</option>
              <option value="lucchese">Lucchese (boot)</option>
              <option value="ariat">Ariat (boot)</option>
              <option value="dress">${t.brand_dress}</option>
              <option value="sneaker">${t.brand_sneaker}</option>
            </select>
          </div>
          <button class="cp-size-cta" data-action="calc-brand">${t.calc}</button>
          <div class="cp-size-result" id="cp-sg-result-brand" style="display:none;"></div>
        </div>
        <!-- TAB 3: Chart -->
        <div class="cp-size-panel" data-panel="chart">
          <h4 style="margin:0 0 12px;font-family: 'Bricolage Grotesque', system-ui, sans-serif;">Men's</h4>
          <table class="cp-size-table">
            <thead><tr><th>US</th><th>EU</th><th>UK</th><th>Foot length</th></tr></thead>
            <tbody>
              <tr><td>7</td><td>40</td><td>6.5</td><td>9.625"</td></tr>
              <tr><td>8</td><td>41</td><td>7.5</td><td>9.937"</td></tr>
              <tr><td>9</td><td>42</td><td>8.5</td><td>10.25"</td></tr>
              <tr><td>10</td><td>43</td><td>9.5</td><td>10.562"</td></tr>
              <tr><td>11</td><td>44</td><td>10.5</td><td>10.875"</td></tr>
              <tr><td>12</td><td>45</td><td>11.5</td><td>11.187"</td></tr>
              <tr><td>13</td><td>46</td><td>12.5</td><td>11.5"</td></tr>
            </tbody>
          </table>
          <h4 style="margin:24px 0 12px;font-family: 'Bricolage Grotesque', system-ui, sans-serif;">Women's</h4>
          <table class="cp-size-table">
            <thead><tr><th>US</th><th>EU</th><th>UK</th><th>Foot length</th></tr></thead>
            <tbody>
              <tr><td>5</td><td>35</td><td>2.5</td><td>8.5"</td></tr>
              <tr><td>6</td><td>36</td><td>3.5</td><td>8.75"</td></tr>
              <tr><td>7</td><td>37</td><td>4.5</td><td>9.25"</td></tr>
              <tr><td>8</td><td>38</td><td>5.5</td><td>9.625"</td></tr>
              <tr><td>9</td><td>39</td><td>6.5</td><td>9.875"</td></tr>
              <tr><td>10</td><td>40</td><td>7.5</td><td>10.25"</td></tr>
              <tr><td>11</td><td>41</td><td>8.5</td><td>10.5"</td></tr>
            </tbody>
          </table>
          <p style="margin-top:16px;font-size:12px;color:#6b6b6b;">
            Width: <strong>B</strong> Narrow · <strong>D</strong> Standard · <strong>EE</strong> Wide · <strong>EEE</strong> Extra Wide
          </p>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
      const close_btn = e.target.closest('.cp-size-modal__close');
      if (close_btn) close();
      const tab = e.target.closest('.cp-size-tab');
      if (tab) {
        const id = tab.getAttribute('data-tab');
        modal.querySelectorAll('.cp-size-tab').forEach(t => t.classList.toggle('cp-size-tab--active', t === tab));
        modal.querySelectorAll('.cp-size-panel').forEach(p => p.classList.toggle('cp-size-panel--active', p.getAttribute('data-panel') === id));
      }
      const act = e.target.closest('[data-action]');
      if (act) handleAction(act.getAttribute('data-action'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('cp-size-modal--open')) close();
    });
    return modal;
  }
  function handleAction(act) {
    if (act === 'calc-length') {
      const gender = modal.querySelector('#cp-sg-gender').value;
      const len = parseFloat(modal.querySelector('#cp-sg-length').value);
      const width = modal.querySelector('#cp-sg-width').value;
      const result = modal.querySelector('#cp-sg-result-length');
      if (!len || len < 7 || len > 14) {
        result.style.display = 'block';
        result.innerHTML = '<p style="color:#fbb;">Enter a foot length between 7 and 14 inches.</p>';
        return;
      }
      const usSize = lookupByLength(len, gender);
      result.style.display = 'block';
      result.innerHTML = `
        <p style="font-size:12px;letter-spacing:0.1em;text-transform:uppercase;margin:0;color:#b8924e;">Your Cuadra Piedreros size</p>
        <p class="cp-size-result__size">US ${usSize}</p>
        <p class="cp-size-result__hint">${widthAdvice(width)}</p>
        <p style="font-size:12px;margin-top:12px;opacity:0.85;">
          Handmade boots break in to your foot. Order this size — they should feel snug on day one and conform to you over 2-4 weeks.
        </p>
      `;
    }
    if (act === 'calc-brand') {
      const size = parseFloat(modal.querySelector('#cp-sg-brand-size').value);
      const brand = modal.querySelector('#cp-sg-brand').value;
      const result = modal.querySelector('#cp-sg-result-brand');
      if (!size || size < 4 || size > 15) {
        result.style.display = 'block';
        result.innerHTML = '<p style="color:#fbb;">Enter a valid size.</p>';
        return;
      }
      const cuadraSize = lookupByBrand(size, brand);
      const offset = BRAND_OFFSETS[brand];
      let advice;
      if (offset === 0) advice = 'Same size as your ' + brand + '.';
      else if (offset < 0) advice = brand[0].toUpperCase() + brand.slice(1) + ' runs large; size down.';
      else advice = brand[0].toUpperCase() + brand.slice(1) + ' runs small; size up.';
      result.style.display = 'block';
      result.innerHTML = `
        <p style="font-size:12px;letter-spacing:0.1em;text-transform:uppercase;margin:0;color:#b8924e;">Your Cuadra Piedreros size</p>
        <p class="cp-size-result__size">US ${cuadraSize}</p>
        <p class="cp-size-result__hint">${advice}</p>
      `;
    }
  }
  function open() {
    ensureModal();
    modal.classList.add('cp-size-modal--open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('cp-size-modal--open');
    document.body.style.overflow = '';
  }
  function init() {
    document.querySelectorAll('.cp-size-trigger').forEach(function (btn) {
      if (btn.dataset.cpInit) return;
      btn.dataset.cpInit = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
  window.CPSizeGuide = { open, close };
})();
/* =====
 cp-quickview.js ===== */
(function () {
  'use strict';
  const isES = (document.documentElement.lang || 'en').toLowerCase().startsWith('es');
  let modal = null;
  function ensure() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cp-quickview';
    modal.innerHTML = '<div class="cp-quickview__backdrop"></div>' +
      '<div class="cp-quickview__inner">' +
      '<button class="cp-quickview__close" aria-label="Close">×</button>' +
      '<div class="cp-quickview__media"></div>' +
      '<div class="cp-quickview__info"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.cp-quickview__close').addEventListener('click', close);
    modal.querySelector('.cp-quickview__backdrop').addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    return modal;
  }
  async function show(handle) {
    ensure();
    modal.classList.add('cp-quickview--open');
    document.body.style.overflow = 'hidden';
    const media = modal.querySelector('.cp-quickview__media');
    const info = modal.querySelector('.cp-quickview__info');
    media.innerHTML = '<div style="padding:40px;text-align:center;color:#888;">Loading…</div>';
    info.innerHTML = '';
    try {
      const r = await fetch('/products/' + handle + '.js');
      const p = await r.json();
      const img = p.featured_image || (p.images && p.images[0]) || '';
      const price = (p.price / 100).toFixed(2);
      const desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 220);
      media.innerHTML = img ? '<img src="' + img + '" alt="' + (p.title || '') + '" loading="eager">' : '';
      info.innerHTML =
        '<p class="cp-quickview__vendor">' + (p.vendor || 'Cuadra Piedreros') + '</p>' +
        '<h3 class="cp-quickview__title">' + p.title + '</h3>' +
        '<p class="cp-quickview__price">$' + price + '</p>' +
        '<p class="cp-quickview__desc">' + desc + (desc.length >= 220 ? '…' : '') + '</p>' +
        '<a href="' + p.url + '" class="cp-quickview__cta">View full product</a>' +
        '<a href="' + p.url + '" class="cp-quickview__view-full">See all details, sizes, and reviews →</a>';
    } catch (e) {
      info.innerHTML = '<p>Unable to load product.</p>';
    }
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('cp-quickview--open');
    document.body.style.overflow = '';
  }
  function inject() {
    document.querySelectorAll('.product-card').forEach(card => {
      if (card.querySelector('.cp-qv-trigger')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const m = link.href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      const handle = m[1];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cp-qv-trigger';
      btn.textContent = (isES?"Vista rápida":"Quick view");
      btn.setAttribute('data-handle', handle);
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        show(handle);
      });
      const figure = card.querySelector('.product-card__figure') || card;
      figure.style.position = figure.style.position || 'relative';
      figure.appendChild(btn);
    });
  }
  function init() {
    inject();
    document.addEventListener('shopify:section:load', inject);
    new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.CPQuickView = { show, close };
})();
/* =====
 cp-bis.js ===== */
/* Cuadra Piedreros — Back-in-Stock ("Avísame cuando vuelva")
 * NO FINISH LINE.
 *
 * The sold-out form is rendered SERVER-SIDE in Liquid (snippets/buy-buttons.liquid)
 * inside `.cp-bis[data-cp-bis]`, so it only ever appears when the selected variant
 * is genuinely sold out. This module only wires the submit behavior.
 *
 * On submit it subscribes the shopper in Klaviyo (company_id RsXRfa, loaded onsite
 * via the Klaviyo app embed) using two paths, in order:
 *   1. Native client-side Back-in-Stock endpoint (auto-fires Klaviyo's BIS flow when
 *      the catalog variant restocks). Requires the Shopify catalog synced to Klaviyo.
 *   2. Fallback: client subscriptions endpoint (creates/identifies the profile +
 *      consents) + a "Back In Stock Request" metric event carrying the variant.
 *      El Arete triggers the win-back flow off that metric.
 * If Klaviyo is unreachable, it still POSTs to /contact so no lead is ever lost.
 */
(function () {
  'use strict';

  var COMPANY_ID = (window.cpBis && window.cpBis.companyId) || 'RsXRfa';
  var NEWSLETTER_LIST = (window.cpBis && window.cpBis.newsletterListId) || ''; // optional: subscribe to a list too
  var KLAVIYO_REVISION = '2024-10-15';

  function emailValid(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function showMsg(form, text, ok) {
    var msg = form.parentNode.querySelector('.cp-bis__msg');
    if (!msg) return;
    msg.style.display = 'block';
    msg.textContent = text;
    msg.style.color = ok ? '#8B1A1A' : '#cb2b2b';
  }

  // --- Path 1: native Klaviyo client-side Back-in-Stock subscription ---------
  // catalogVariantId format for a Shopify-synced catalog: $shopify:::$default:::<variant_id>
  function nativeBis(email, variantId) {
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    });
  }

  // --- Path 2: subscribe profile + emit metric (works without catalog sync) --
  function fallbackSubscribe(email, listId) {
    if (!listId) return Promise.resolve({ ok: true, skipped: true });
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Back in Stock (Piedreros)',
          profile: { data: { type: 'profile', attributes: {
            email: email
          } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    });
  }

  function emitMetric(email, data) {
    // Onsite SDK (loaded by the Klaviyo app embed)
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ $email: email });
      }
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Back In Stock Request', data);
        return;
      }
    } catch (e) {}
    // REST fallback if the onsite SDK isn't ready
    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: data,
          metric: { data: { type: 'metric', attributes: { name: 'Back In Stock Request' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  // --- Lossless fallback to Shopify so a lead is never dropped ---------------
  function shopifyContactFallback(email, info) {
    try {
      var params = new URLSearchParams();
      params.set('form_type', 'contact');
      params.set('utf8', '✓');
      params.set('contact[name]', '[BIS] ' + email);
      params.set('contact[email]', email);
      params.set('contact[body]',
        'Avísame cuando vuelva\n\nProduct: ' + info.product +
        '\nVariant: ' + info.variantTitle +
        '\nVariant ID: ' + info.variantId +
        '\nURL: ' + window.location.href);
      params.set('contact[tags]', 'back_in_stock,bis:' + info.handle);
      fetch('/contact#contact_form', { method: 'POST', body: params, mode: 'no-cors' }).catch(function () {});
    } catch (e) {}
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var root = form.closest('.cp-bis');
    var email = (form.email.value || '').trim();

    if (!emailValid(email)) {
      showMsg(form, 'Enter a valid email.', false);
      return;
    }

    var info = {
      variantId: root.getAttribute('data-variant-id') || '',
      product: root.getAttribute('data-product-title') || '',
      handle: root.getAttribute('data-product-handle') || '',
      variantTitle: root.getAttribute('data-variant-title') || ''
    };

    var btn = form.querySelector('.cp-bis__btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Signing you up…'; }

    var metricData = {
      ProductName: info.product,
      VariantTitle: info.variantTitle,
      VariantId: info.variantId,
      ProductHandle: info.handle,
      ProductURL: window.location.href
    };

    // Fire everything; we resolve the UI on best-effort success.
    emitMetric(email, metricData);
    shopifyContactFallback(email, info);
    fallbackSubscribe(email, NEWSLETTER_LIST).catch(function () {});

    nativeBis(email, info.variantId)
      .then(function (r) {
        finish(form, btn, root);
      })
      .catch(function () {
        // Native path failed (e.g. catalog not synced) — metric path already covers it.
        finish(form, btn, root);
      });

    // localStorage breadcrumb
    try {
      var saved = JSON.parse(localStorage.getItem('cp_bis_requests') || '[]');
      saved.push({ email: email, variantId: info.variantId, product: info.product, ts: Date.now() });
      localStorage.setItem('cp_bis_requests', JSON.stringify(saved));
    } catch (e) {}
  }

  function finish(form, btn, root) {
    if (root.getAttribute('data-cp-bis-done')) return;
    root.setAttribute('data-cp-bis-done', '1');
    showMsg(form, '✓ Done. We\'ll let you know the moment it\'s back — you first.', true);
    form.reset();
    form.style.display = 'none';
    if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
  }

  function wire(scope) {
    var roots = (scope || document).querySelectorAll('.cp-bis[data-cp-bis]');
    for (var i = 0; i < roots.length; i++) {
      var form = roots[i].querySelector('.cp-bis__form');
      if (form && !form.getAttribute('data-cp-bis-wired')) {
        form.setAttribute('data-cp-bis-wired', '1');
        form.addEventListener('submit', onSubmit);
      }
    }
  }

  function init() {
    wire(document);
    // The theme swaps the product form via <product-rerender> on variant change;
    // re-wire any freshly injected sold-out forms.
    document.addEventListener('shopify:section:load', function () { wire(document); });
    var obsTarget = document.querySelector('product-rerender') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { wire(document); }).observe(obsTarget, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* =====
 cp-cart-upsell.js ===== */
(function () {
  'use strict';
  const isES = (document.documentElement.lang || 'en').toLowerCase().startsWith('es');
  async function render(host) {
    const productId = host.getAttribute('product-id') || host.getAttribute('product');
    const limit = parseInt(host.getAttribute('limit') || '3', 10);
    if (!productId) return;
    try {
      const r = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=complementary`);
      const data = await r.json();
      const products = (data.products || []).slice(0, limit);
      if (!products.length) { host.remove(); return; }
      const grid = document.createElement('div');
      grid.className = 'cp-cart-upsell__grid';
      grid.innerHTML = products.map(p => {
        const img = (p.featured_image && p.featured_image.startsWith('//')) ? `https:${p.featured_image}` : (p.featured_image || p.images?.[0] || '');
        const price = (p.price / 100).toFixed(2);
        const variantId = p.variants?.[0]?.id || p.id;
        const addLabel = isES ? 'Agregar' : 'Add';
        const imgTag = img ? `<img src="${img.replace(/\.(jpg|jpeg|png|webp)/i, '_400x.$1')}" alt="${escapeHtml(p.title)}" loading="lazy">` : '';
        return `
          <div class="cp-cu-item">
            <a href="${p.url}" style="text-decoration:none;color:inherit;">
              <div class="cp-cu-item__media">${imgTag}</div>
              <div class="cp-cu-item__info">
                <p class="cp-cu-item__title">${escapeHtml(p.title)}</p>
                <p class="cp-cu-item__price">$${price}</p>
              </div>
            </a>
            <button type="button" class="cp-cu-item__add" data-variant="${variantId}" data-title="${escapeHtml(p.title)}">${addLabel}</button>
          </div>`;
      }).join('');
      host.innerHTML = '';
      host.appendChild(grid);
      grid.querySelectorAll('.cp-cu-item__add').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const variantId = btn.dataset.variant;
          btn.disabled = true;
          btn.textContent = isES ? 'Agregando…' : 'Adding…';
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });
            if (res.ok) {
              btn.textContent = isES ? '✓ Agregado' : '✓ Added';
              setTimeout(() => window.location.reload(), 400);
            } else {
              btn.textContent = isES ? 'Error' : 'Error';
              btn.disabled = false;
            }
          } catch (err) {
            btn.textContent = isES ? 'Error' : 'Error';
            btn.disabled = false;
          }
        });
      });
    } catch (e) {
      host.remove();
    }
  }
  function escapeHtml(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }
  function init() {
    document.querySelectorAll('[data-cp-cart-upsell]').forEach(render);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
/* =====
 cp-popup.js ===== */
(function () {
  'use strict';
  const KEY_DISMISSED = 'cp_popup_dismissed_v1';
  const KEY_SUBSCRIBED = 'cp_popup_subscribed_v1';
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const DELAY_MS = isMobile ? 30000 : 18000; // 30s mobile, 18s desktop
  const EXIT_INTENT_THRESHOLD = 5;
  if (localStorage.getItem(KEY_DISMISSED) || localStorage.getItem(KEY_SUBSCRIBED)) return;
  let popupShown = false;
  let popupEl = null;
  function build() {
    const div = document.createElement('div');
    div.className = 'cp-popup';
    const isES = (document.documentElement.lang || 'en').toLowerCase().startsWith('es');
    const t = isES ? {
      eyebrow: 'Bienvenido al rancho',
      title: 'Ahorra 10%<br>en tu primera compra',
      subtitle: 'Acceso anticipado a nuevos drops, pieles limitadas y noticias del taller.',
      placeholder: 'tu@correo.com',
      btn: 'Get my code',
      fine: 'Sin spam. Date de baja cuando quieras.',
      dismiss: 'No gracias, prefiero pagar precio completo'
    } : {
      eyebrow: 'Welcome to the herd',
      title: 'Get 10% off<br>your first order',
      subtitle: 'Plus first access to new drops, limited skins, and stories from the workshop.',
      placeholder: 'your@email.com',
      btn: 'Get my code',
      fine: 'No spam. Unsubscribe any time.',
      dismiss: "No thanks, I'll pay full price"
    };
    div.innerHTML = `
      <div class="cp-popup__backdrop" data-cp-popup-close></div>
      <div class="cp-popup__inner" role="dialog" aria-modal="true" aria-labelledby="cp-popup-title">
        <button class="cp-popup__close" aria-label="Close" data-cp-popup-close>×</button>
        <div class="cp-popup__content">
          <p class="cp-popup__eyebrow">${t.eyebrow}</p>
          <h2 id="cp-popup-title" class="cp-popup__title">${t.title}</h2>
          <p class="cp-popup__subtitle">${t.subtitle}</p>
          <form class="cp-popup__form" id="cp-popup-form" novalidate>
            <input type="email" name="email" placeholder="${t.placeholder}" required class="cp-popup__email">
            <button type="submit" class="cp-popup__btn">${t.btn}</button>
          </form>
          <p class="cp-popup__fine">${t.fine}</p>
          <button type="button" class="cp-popup__dismiss" data-cp-popup-close>${t.dismiss}</button>
        </div>
      </div>
    `;
    document.body.appendChild(div);
    div.querySelectorAll('[data-cp-popup-close]').forEach(b => b.addEventListener('click', dismiss));
    div.querySelector('#cp-popup-form').addEventListener('submit', subscribe);
    document.addEventListener('keydown', function escClose(e) {
      if (e.key === 'Escape' && popupShown) dismiss();
    });
    return div;
  }
  function show() {
    if (popupShown) return;
    popupEl = build();
    requestAnimationFrame(() => popupEl.classList.add('cp-popup--open'));
    popupShown = true;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!popupEl) return;
    popupEl.classList.remove('cp-popup--open');
    setTimeout(() => { popupEl?.remove(); popupEl = null; }, 300);
    document.body.style.overflow = '';
  }
  function dismiss() {
    localStorage.setItem(KEY_DISMISSED, Date.now().toString());
    close();
  }
  function subscribe(e) {
    e.preventDefault();
    const form = e.target;
    const email = form.email.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      form.email.focus();
      form.email.style.borderColor = '#cb2b2b';
      return;
    }
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ $email: email, cp_first_purchase_discount: '10OFF' });
      }
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Subscribed via Popup', { source: 'cp_popup_v1' });
      }
    } catch (err) {}
    try {
      const fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter,popup');
      fetch('/contact#contact_form', { method: 'POST', body: fd, mode: 'no-cors' }).catch(()=>{});
    } catch (err) {}
    localStorage.setItem(KEY_SUBSCRIBED, email);
    const inner = popupEl.querySelector('.cp-popup__content');
    const isES2 = (document.documentElement.lang || 'en').toLowerCase().startsWith('es');
    const sBase = isES2 ? '/es' : '';
    inner.innerHTML = isES2 ? `
      <p class="cp-popup__eyebrow">Welcome!</p>
      <h2 class="cp-popup__title">Ya eres parte de<br>Cuadra Piedreros.</h2>
      <p class="cp-popup__subtitle">Use code <strong style="color:#b8924e;font-size:1.4rem;letter-spacing:0.1em;">CUADRA10</strong> for 10% off your first order.</p>
      <p class="cp-popup__fine">Revisa tu correo para el email de bienvenida.</p>
      <a href="${sBase}/collections/mens-boots" class="cp-popup__btn" style="display:inline-block;text-decoration:none;text-align:center;">Empezar a comprar</a>
    ` : `
      <p class="cp-popup__eyebrow">You're in</p>
      <h2 class="cp-popup__title">Welcome to<br>Cuadra Piedreros.</h2>
      <p class="cp-popup__subtitle">Use code <strong style="color:#b8924e;font-size:1.4rem;letter-spacing:0.1em;">CUADRA10</strong> at checkout for 10% off your first order.</p>
      <p class="cp-popup__fine">Watch your inbox for your welcome email.</p>
      <a href="/collections/mens-boots" class="cp-popup__btn" style="display:inline-block;text-decoration:none;text-align:center;">Start shopping</a>
    `;
    setTimeout(close, 8000);
  }
  function triggerOnDelay() {
    setTimeout(show, DELAY_MS);
  }
  function triggerOnExitIntent() {
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < EXIT_INTENT_THRESHOLD && !popupShown) show();
    }, { once: true });
  }
  function triggerOnScroll() {
    let scrolled = false;
    window.addEventListener('scroll', function onScroll() {
      if (scrolled) return;
      const pct = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      if (pct > 35 && !popupShown) {
        scrolled = true;
        show();
      }
    }, { passive: true });
  }
  function init() {
    const path = window.location.pathname;
    if (path.includes('/cart') || path.includes('/checkout') || path.includes('/account')) return;
    triggerOnDelay();
    triggerOnExitIntent();
    triggerOnScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
/* =====
 cp-fomo.js ===== */
(function () {
  'use strict';
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  if (window.CPFomoActive) return;
  window.CPFomoActive = true;
  function getData() {
    return window.CPFomoData || [];
  }
  let toast;
  function ensure() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'cp-fomo';
    toast.innerHTML = '<img class="cp-fomo__img" alt="">' +
      '<div class="cp-fomo__text"></div>' +
      '<button class="cp-fomo__close" aria-label="Close">×</button>';
    document.body.appendChild(toast);
    toast.querySelector('.cp-fomo__close').addEventListener('click', hide);
    return toast;
  }
  function show(entry) {
    const el = ensure();
    el.querySelector('.cp-fomo__img').src = entry.image || '';
    const text = el.querySelector('.cp-fomo__text');
    text.innerHTML = '<strong>' + escape(entry.name) + '</strong> from ' + escape(entry.location) +
      '<br>' + escape(entry.product) +
      '<div class="cp-fomo__time">' + escape(entry.time) + '</div>';
    el.classList.add('cp-fomo--show');
    setTimeout(hide, 6000);
  }
  function hide() { if (toast) toast.classList.remove('cp-fomo--show'); }
  function escape(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function start() {
    const data = getData();
    if (!data.length) return;
    let i = Math.floor(Math.random() * data.length);
    function loop() {
      show(data[i % data.length]);
      i++;
      setTimeout(loop, 22000); // every ~22s
    }
    setTimeout(loop, isMobile ? 18000 : 8000); // initial delay 8s
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
